import { atom } from 'recoil';

export const currentCoverableIdAtom = atom<{
    fixedId: string | undefined;
    lobCode: string | undefined;
}>({
    key: 'currentCoverableAtom',
    default: undefined
});
